// @flow

const EMAIL_PATTERN = /(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/g;
export function sanitizePII(string: string, replaceWith: string = ''): string {
  return string.replace(EMAIL_PATTERN, replaceWith);
}
